import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import bgPattern from 'src/assets/images/resort/bg-pattern.svg';
import { ConfirmButton } from 'src/components/shared/buttons/ConfirmButton';
import { LogoMonotone } from 'src/components/shared/LogoMonotone';
import { TitleHeader } from 'src/components/shared/TitleHeader';
import { WaveHeadPattern } from 'src/components/shared/WaveHeadPattern';
import { RootState } from 'src/features';
import { UserColor } from 'src/models/resort/UserColor';
import { UserColorHeader } from '../common/UserColorHeader';

interface ResortDeepLinkContainerProps {
  isDefaultHeader: boolean; // ユーザーカラーデコのヘッダではなくデフォルトのヘッダを使用するか
  userColor?: UserColor;
  decoId?: number;
}

export const ResortDeepLinkContainer: React.FC<ResortDeepLinkContainerProps> = ({
  isDefaultHeader,
  userColor,
  decoId,
  children
}) => {
  const { t } = useTranslation('resort');
  const { displayedUserProfile } = useSelector((state: RootState) => state.resort);
  const history = useHistory();
  const handleGoHomeClick = () => {
    history.replace('/players/home');
  };

  return (
    <main
      className={css`
        width: 100%;
        height: 100%;
        overflow: hidden;
        background: url(${bgPattern});
      `}
    >
      {isDefaultHeader ? (
        <TitleHeader title={t('top')} color="#f1ccd0" />
      ) : (
        <UserColorHeader title={t('top')} userColor={userColor} decoId={decoId} />
      )}
      <div
        className={css`
          display: flex;
          flex-direction: column;
          height: calc(100% - 52px);
        `}
      >
        <div
          className={css`
            flex-grow: 1;
            overflow: auto;
          `}
        >
          {children}
        </div>
        <div
          className={css`
            flex: 0 0 auto;
            position: relative;
            padding: 0 20px 8px;
            padding: 0 20px calc(env(safe-area-inset-bottom) + 8px);
            background: #f5f1e3;
            .wave {
              position: absolute;
              top: -19px; // 1px重ねておく
              right: 0;
              bottom: 0;
              left: 0;
              height: 20px;
            }
            .go-home {
              max-width: 480px;
              margin: 0 auto;
            }
            .go-home-content {
              display: flex;
              flex-direction: column;
              align-items: center;
              font-size: 12px;
            }
          `}
        >
          <div className="wave">
            <WaveHeadPattern fillColor="#f5f1e3" />
          </div>
          <div className="go-home">
            <ConfirmButton
              onClick={handleGoHomeClick}
              disabled={displayedUserProfile?.state === 'pending'}
            >
              <div className="go-home-content">
                <LogoMonotone scale={0.7} />
                {t('go_to_home')}
              </div>
            </ConfirmButton>
          </div>
        </div>
      </div>
    </main>
  );
};
